import React, { useState, useEffect } from 'react';

const ProtectedSection = (props) => {
    const [userPermissions, setUserPermission] = useState([]);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        try {
            const arr = JSON.parse(localStorage.getItem('permissions'));
            setUserPermission(arr);
            ValidatePermission(arr)
        } catch (error) {
            console.log(">>>>>>>>>", error);
        }
    }, []);

    const ValidatePermission = (perm) => {
        let hasPermission = false;
        if (props.permissions && Array.isArray(props.permissions)) {
            for (let p of props.permissions) {
                if (perm.includes(p) == true) {
                    hasPermission = true;
                    break;
                }
            }
        }
        setVisible(hasPermission);
    }

    return (
        <>{visible ? props.children : <></>}</>
    )
}


const hasPermission = (permission) => {
    let result = false;
    try {
        const arr = JSON.parse(localStorage.getItem('permissions'));
        result = arr.includes(permission);

    } catch (error) {
        console.log("Error on permission fetch", error)
        result = false;
    }
    return result;
}


export default ProtectedSection;
export { ProtectedSection, hasPermission };
